import { useEffect, useState } from "react";

// "Starts in 2d 4h 11m" style label, ticking on a 1-minute interval (seconds
// don't matter for this copy, and a slower tick avoids unnecessary rerenders
// for a page that may have several cards mounted at once).
export default function useCountdown(targetDate) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const interval = setInterval(() => setNow(Date.now()), 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const targetMs = targetDate instanceof Date ? targetDate.getTime() : NaN;
  if (Number.isNaN(targetMs)) {
    return { label: "", hasStarted: false };
  }

  const diffMs = targetMs - now;
  if (diffMs <= 0) {
    return { label: "Starting now", hasStarted: true };
  }

  const totalMinutes = Math.floor(diffMs / 60000);
  const days = Math.floor(totalMinutes / (60 * 24));
  const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
  const minutes = totalMinutes % 60;

  const parts = [];
  if (days > 0) parts.push(`${days}d`);
  if (days > 0 || hours > 0) parts.push(`${hours}h`);
  parts.push(`${minutes}m`);

  return { label: `Starts in ${parts.join(" ")}`, hasStarted: false };
}
